import { useEffect } from "react";

// Lightweight SEO hook — sets <title>, meta description, canonical URL and
// Open Graph / Twitter card tags directly on document.head without pulling
// in a library like react-helmet. CRA renders a single index.html so this
// is enough for Googlebot (which executes JS for crawled SPAs).
export default function useSEO({ title, description, canonical, ogImage, jsonLd, keywords }) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) setMeta("name", "description", description);
    if (keywords) setMeta("name", "keywords", keywords);
    if (canonical) setLink("canonical", canonical);

    // Open Graph
    if (title) setMeta("property", "og:title", title);
    if (description) setMeta("property", "og:description", description);
    if (canonical) setMeta("property", "og:url", canonical);
    if (ogImage) setMeta("property", "og:image", ogImage);
    setMeta("property", "og:type", "website");

    // Twitter
    if (title) setMeta("name", "twitter:title", title);
    if (description) setMeta("name", "twitter:description", description);
    if (ogImage) setMeta("name", "twitter:image", ogImage);
    setMeta("name", "twitter:card", "summary_large_image");

    // Structured data (JSON-LD)
    if (jsonLd) {
      let s = document.getElementById("seo-jsonld");
      if (!s) {
        s = document.createElement("script");
        s.type = "application/ld+json";
        s.id = "seo-jsonld";
        document.head.appendChild(s);
      }
      s.textContent = JSON.stringify(jsonLd);
    }
  }, [title, description, canonical, ogImage, jsonLd, keywords]);
}

function setMeta(attr, key, value) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

function setLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}
